export const isAuthenticated = () => {
    if (localStorage.getItem('coachToken')) {
        return localStorage.getItem('coachToken')
    }
    return false
}
